<template>
  <section class="mod-choice-process processarea clearfix">
    <preview-job-comments
      :comments="commentHighlights"
      class="comment-bar-process"
      :is-show="isShowComment"
      v-on="$listeners"
    />
    <div
      v-if="isShowTextCount"
      class="pega-count-moji-area process"
    >
      <preview-text-count
        v-if="!isClientJob"
        name="選考プロセス"
        :count-target="processDetail"
      />
      <template v-for="(process,i) in processes">
        <preview-text-count
          :key="i"
          :name="'STEP' + process.stepId"
          :count-target="process"
        />
      </template>
    </div>
    <h4 class="mod-title-lv2">
      選考プロセス
    </h4>
    <div class="inner">
      <ol class="step">
        <template v-for="(process,i) in processes">
          <li :key="i">
            <p
              class="title"
              :data-test="`title-${i + 1}`"
            >
              <span>STEP</span><span class="number">0{{ process.stepId }}</span>
            </p>
            <div class="step-inner">
              <p
                :id="targetIdMap.process + '-' + process.stepId"
                class="pega-pre-wrap"
                :data-test="`process-${i + 1}`"
                v-text="process.value"
              />
            </div>
          </li>
          <div
            v-if="processes.length > i + 1"
            :key="'arrow-' + i"
            :data-test="`arrow-${i + 1}`"
            class="arrow-img"
          >
            <img
              :src="userEndPoint + processArrow"
              alt="v"
            >
          </div>
        </template>
      </ol>
      <div
        v-if="processDetail.value"
        class="body"
      >
        <p
          :id="targetIdMap.processDetail"
          class="pega-pre-wrap"
          data-test="process-detail"
          v-text="processDetail.value"
        />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@use "@/styles/preview/pc/base" as *;

div.comment-bar-process {
  margin-right: -44.7% !important;
  width: 31.2%;
}
.arrow-img{
  // STEPボックス(li)と同じ幅にして左詰めにすることで、選考プロセス詳細の非表示時に
  // ol.stepセルが全幅へ広がっても、▼をSTEPボックス直下の中央に固定する
  width: 456px;
  text-align:center;
  margin-bottom: 10px;
}
</style>

<script>
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import PreviewTextCount from '@/components/atoms/PreviewTextCount'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  components: {
    PreviewJobComments,
    PreviewTextCount
  },
  mixins: [jobPreviewCommon],
  props: {
    processes: {
      type: Array,
      required: true
    },
    processDetail: {
      type: Object,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    },
    isShowTextCount: {
      type: Boolean,
      required: true
    },
    isClientJob: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    processArrow: () => '/common/img/module/job_process_arrow_bottom01.png'
  },
  mounted () {
    this.commentHighlights.forEach((commentHighlight) => {
      this.setHighlight(commentHighlight)
    })
  }
}
</script>
